import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {KompenzacijaDocument} from "./KompenzacijaDocument";
import {IzvestajRevizijeDocument} from "./IzvestajRevizijeDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: datum revizije, vrsta revizije
export const izvestajRevizijeDocumentFields: IntercateKeysMap<IzvestajRevizijeDocument, EntityField<IzvestajRevizijeDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	onDate: {
		name: "onDate", dataType: EntityFieldDataType._date, label: "Datum revizije",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	revisionType: {
		name: "revisionType", dataType: EntityFieldDataType._string, label: "Vrsta revizije",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<IzvestajRevizijeDocument>> = [
	izvestajRevizijeDocumentFields.indexingNumber,
	izvestajRevizijeDocumentFields.indexingDate,
	izvestajRevizijeDocumentFields.documentNumber,
	izvestajRevizijeDocumentFields.documentDate,
	izvestajRevizijeDocumentFields.assignedTo,
	izvestajRevizijeDocumentFields.clientId,
	izvestajRevizijeDocumentFields.sectorId,
	izvestajRevizijeDocumentFields.onDate,
	izvestajRevizijeDocumentFields.revisionType,
	izvestajRevizijeDocumentFields.tags,
	izvestajRevizijeDocumentFields.description,
	izvestajRevizijeDocumentFields.parentId
]

export const izvestajRevizijeDocumentFieldsDescriptor: EntityFieldsDescriptor<IzvestajRevizijeDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
